import { Link } from 'react-router';

/* ============================================================================
   /403 — signed in, but not allowed.
   ----------------------------------------------------------------------------
   A separate screen from /404 because they mean opposite things to the person
   reading them. "Not found" invites another try at the address; this one says
   the address is right and the account is wrong, so the next step is asking
   the owner rather than retyping.

   `requireRole()` in the API answers FORBIDDEN and until now the dashboard had
   nowhere to land. It is a landing target, not a gate — the gate is the API's,
   because anyone can edit the JavaScript running on their own machine.
   ========================================================================== */

export function ForbiddenPage() {
  return (
    <div className="centre">
      <div className="centre__box card stack">
        <h1>You do not have access</h1>
        <p className="muted">
          This screen is for the owner only. Your account is staff — ask the owner to grant you
          access.
        </p>
        <Link to="/" className="btn">
          Go to overview
        </Link>
      </div>
    </div>
  );
}
